import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

// Service
import AuthService from "../../services/Auth.service";
import AuthUserService from "../../services/Auth.User.service";

const initialState = {
  token: null,
  tokenAliveTime: null,
  recentLogins: null,
  user: null,
};

export const fetchUser = createAsyncThunk(
  "users/fetchUser",
  async (_, thunkAPI) => {
    const response = await AuthService.getUser();
    if (response.error) {
      return thunkAPI.rejectWithValue(response.error);
    }
    return response.data;
  }
);

export const fetchRecentLogins = createAsyncThunk(
  "users/fetchRecentLogins",
  async (_, thunkAPI) => {
    const response = await AuthUserService.getRecentLogins();
    if (response.error) {
      return thunkAPI.rejectWithValue(response.error);
    }
    return response.data;
  }
);

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    clean(state) {
      state.value = null;
    },
    setToken(state, action) {
      state.token = action.payload.token;
      state.tokenAliveTime = action.payload.tokenAliveTime;
    },
    setUser(state, action) {
      state.user = action.payload;
    },
  },
  extraReducers: {
    [fetchUser.fulfilled.type]: (state, action) => {
      state.user = action.payload;
    },
    [fetchRecentLogins.fulfilled.type]: (state, action) => {
      state.recentLogins = action.payload;
    },
  },
});

export const userActions = userSlice.actions;

export default userSlice;
